function getCancerDisclaimers(state) {
    switch (state) {
        case 'AR':
            return 'Policies B70100AR, B70200AR, B70300AR, B7010EPAR, B7020EPAR';
        case 'ID':
            return 'Policies B70100ID, B70200ID, B70300ID, B7010EPID, B7020EPID';
        case 'OK':
            return 'Policies B70100OK, B70200OK, B70300OK, B7010EPOK, B7020EPOK';
        case 'OR':
            return 'Policies B70100OR, B70200OR, B70300OR, B7010EPOR, B7020EPOR';
        case 'PA':
            return 'Policies B70100PA, B70200PA, B70300PA';
        case 'TX':
            return 'Policies B70100TX, B70200TX, B70300TX, B7010EPTX, B7020EPTX';
        case 'NY':
            return '*Not available in NY';
        case 'VA':
            return '*Not available in VA';
        default:
            return null;
    }
}

function getAccidentDisclaimers(state) {
    switch (state) {
        case 'AR':
            return 'Policy A37000AR';
        case 'ID':
            return 'Policy A37000ID';
        case 'NY':
            return 'Policy NY37000';
        case 'OK':
            return 'Policy A37000OK';
        case 'OR':
            return 'Policy A37000OR';
        case 'PA':
            return 'Policy A37000PA';
        case 'TX':
            return 'Policy A37000TX';
        case 'VA':
            return 'Policies A371AAVA & A371BAVA'
        default:
            return null;
    }
}

function getCriticalIllnessDisclaimers(state) {
    switch (state) {
        case 'AR':
            return 'Policies B71100AR & B7110HAR';
        case 'OR':
            return 'Policies B71100OR & B7110HOR';
        case 'PA':
            return 'Policies B71100PA & B7110HPA';
        case 'TX':
            return 'Policies B71100TX & B7110HTX';
        case 'ID':
            return '*Not available in ID';
        case 'NJ':
            return '*Not available in NJ';
        case 'NY':
            return '*Not available in NY';
        case 'OK':
            return '*Not available in OK';
        case 'VA':
            return '*Not available in VA';
        default:
            return null;
    }
}

function getCancerDisabled(state) {
    switch (state) {
        case 'NY':
        case 'VA':
            return true
        default:
            return false;
    }
}

function getCriticalIllnessDisabled(state) {
    switch (state) {
        case 'ID':
        case 'NY':
        case 'OK':
        case 'VA':
            return true;
        default:
            return false;
    }
}

export { getCancerDisclaimers, getAccidentDisclaimers, getCriticalIllnessDisclaimers, getCancerDisabled, getCriticalIllnessDisabled }


// WEBPACK FOOTER //
// ./src/components/Quoters/Supplemental/Helpers/Disclaimers.js